import {MasterOfActsAPI} from "../api/api";

export const numberFormatter = (number) => {
    if (!number) {
        return ''
    }
    if (number?.includes('_')) {
        const splitNumber = number.split('.')
        const filteredSplitNumber = splitNumber.filter(f => f[0] !== '_')
        return filteredSplitNumber.join('.')
    }
    return number
}


export const createDescription = (number, descriptionTemplate) => {
    if (!descriptionTemplate) {
        return ''
    }
    return descriptionTemplate?.replace('$number', numberFormatter(number))

}



const copyTemplateFields = async (from, to) => {
    const toCopyFields = await MasterOfActsAPI.getFieldTemplates(from)

    if (toCopyFields.status === 200) {
        for (const field of toCopyFields.data) {
            await MasterOfActsAPI.createFieldTemplate({...field, act_template: to})
        }
    }
}

window.copyTemplateFields = copyTemplateFields